module.exports = __webpack_public_path__ + "img/Willis Mill Station Concepts_Page_2.63682342.jpg";